"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Checkbox = _styledComponents["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 0;\n    position: relative;\n    font-size: 0.875rem !important;\n    cursor: pointer;\n    font-weight: 300 !important;\n\n    &:hover {\n        .checkbox {\n            border-color: ", ";\n        }\n    }\n\n    input {\n        width: auto;\n        margin-right: 15px;\n        opacity: 0;\n        visibility: hidden;\n        height: 30px;\n    }\n\n    .checkbox {\n        position: absolute;\n        top: calc(50% - 10px);\n        left: 0;\n\n        display: inline-block;\n        height: 19px;\n        width: 19px;\n        border: 1px solid ", ";\n        transition: border 0.2s linear;\n        background-color: #ffffff;\n    }\n\n    &.align-right {\n        .checkbox {\n            left: auto;\n            right: 0;\n        }\n    }\n\n    input:not(.sortable-checkbox):checked,\n    input.sortable-checkbox[data-value='true'] {\n        + .checkbox {\n            &:before {\n                content: '';\n                display: block;\n                height: 100%;\n                width: 100%;\n                background-image: url(data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhciIgZGF0YS1pY29uPSJjaGVjayIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLWNoZWNrIGZhLXctMTYgbXItMiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMzM4Y2U0IiBkPSJNNDM1Ljg0OCA4My40NjZMMTcyLjgwNCAzNDYuNTFsLTk2LjY1Mi05Ni42NTJjLTQuNjg2LTQuNjg2LTEyLjI4NC00LjY4Ni0xNi45NzEgMGwtMjguMjg0IDI4LjI4NGMtNC42ODYgNC42ODYtNC42ODYgMTIuMjg0IDAgMTYuOTcxbDEzMy40MjEgMTMzLjQyMWM0LjY4NiA0LjY4NiAxMi4yODQgNC42ODYgMTYuOTcxIDBsMjk5LjgxMy0yOTkuODEzYzQuNjg2LTQuNjg2IDQuNjg2LTEyLjI4NCAwLTE2Ljk3MWwtMjguMjg0LTI4LjI4NGMtNC42ODYtNC42ODYtMTIuMjg0LTQuNjg2LTE2Ljk3IDB6Ij48L3BhdGg+PC9zdmc+);\n                background-size: 12px;\n                background-repeat: no-repeat;\n                background-position: center;\n            }\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.brand;
}, function (props) {
  return props.theme.admin.font.color;
});

exports.Checkbox = Checkbox;